import moment from 'moment';

const today = moment();

export default {
	current: {
		index: parseInt(today.format('MM')) - 1,
		value: today.format('MMMM').toUpperCase()
	}
};



// WEBPACK FOOTER //
// ./sources/components/calendar/month/state.js